<template>
  <b-row>
    <b-col>
      <b-row style="margin-bottom: 15px">
        <b-col>
          <b-form-input v-model="module_infos.nom" placeholder="Nom de l'épreuve" size="sm"></b-form-input>
        </b-col>
        <b-col>
          <b-form-input v-model="module_infos.annee_epreuve" placeholder="Année de l'épreuve" size="sm"></b-form-input>
        </b-col>
        <b-col>
          <b-form-input v-model="module_infos.date_epreuve" placeholder="Date de l'épreuve" size="sm"></b-form-input>
        </b-col>
      </b-row>

      <b-row style="margin-bottom: 15px">
        <b-col>
          <b-form-input v-model="module_infos.type_competition" placeholder="Type de compétition" size="sm"></b-form-input>
        </b-col>
        <b-col>
          <b-form-input v-model="module_infos.ville_competition" placeholder="Ville de compétition" size="sm"></b-form-input>
        </b-col>
        <b-col>
          <b-form-input v-model="module_infos.code_ville_competition" placeholder="Code ville compétition" size="sm"></b-form-input>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col md="6" sm="12">
          <img :src="module_infos.url_flyer" v-if="module_infos.url_flyer" @error="module_infos.url_flyer = ''" style="width: 100px; height: auto" />
          <b-form-group label="Importer le Flyer">
            <input type="file" @change="onFileChangeFlyer" />
          </b-form-group>
        </b-col>
        <b-col md="6" sm="12">
          <b-form-group label="Associer un diplôme : ">
            <b-form-select size="sm" v-model="selectedDiplome" :options="list_diplomes" @input="$emit('changeSelectedDiplome', selectedDiplome)"></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import Axios from "axios";
export default {
  props: ["module_infos", "list_diplomes"],
  data() {
    return {
      selectedDiplome: null,
    };
  },
  methods: {
    onFileChangeFlyer(e) {
      var data = new FormData();
      var _this = this;
      var file = e.target.files[0];
      data.append("image", file, file.name);
      Axios.post(this.$store.getters.base_url + "/import/diplome/uploadBackground.php", data).then(function (response) {
        if (response.data.length > 0) {
          _this.$emit("uploadFlyer", "https://sportips.fr/plateformeResultats/uploads/" + response.data);
        }
      });
    },
  },
};
</script>

<style>
.extra_links {
  margin-bottom: 10px;
}
</style>